<script setup>
import { cleanNodeName } from '../../composables/formatUtils'
</script>

<template>
  <div class="org-unit">
    <div class="py-2 border-bottom border-dark" :class="!depth ? 'd-none' : ''">
      <div :style="indent">
        <div class="d-inline-block" role="button">
          <div v-if="node.nodes.length && depth > 1" @click="toggleNodes">
            <svg class="bi" width="16" height="16" fill="currentColor">
              <use v-if="showNodes" xlink:href="@/assets/icons/icons.svg#dash"/>
              <use v-else xlink:href="@/assets/icons/icons.svg#plus"/>
            </svg>
          </div>
          <div v-else-if="depth > 1" class="tree-node-collapse-placeholder"></div>
        </div>
        <div class="cont-icon-org-unit d-inline-block me-1">
          <svg class="bi" width="16" height="16" fill="currentColor">
            <use xlink:href="@/assets/icons/icons.svg#orgunit"/>
          </svg>
        </div>
        <div class="d-inline-block tree-node-name">
          <span @click="selectOrgUnit(node)" class="org-unit-name" :class="selectedOrgUnit.id === node.id ? 'fw-bold' : ''" role="button">{{ cleanNodeName(node.name) }}</span>
        </div>
      </div>
    </div>
    <div v-if="filteredNode && showNodes">
      <OrgUnitTree v-for="node in filteredNode.nodes" :key="node.id" :node="node" :depth="depth + 1" :mode="mode" :searchText="searchText" :selectedTree="selectedTree" :autoOpenDepth="autoOpenDepth"></OrgUnitTree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrgUnitTree',
  props: {
    node: Object,
    depth: Number,
    mode: String,
    searchText: String,
    selectedTree: String,
    autoOpenDepth: Number
  },
  data () {
    return {
      showNodes: this.depth < this.autoOpenDepth
    }
  },
  computed: {
    filteredNode () {
      return this.filterNode(this.node, this.searchText, this.selectedTree)
    },
    indent () {
      if (this.node.nodes && this.depth) {
        return { paddingLeft: `${(this.depth - 1) * 15}px` }
      } else {
        return { paddingLeft: `${this.depth * 15}px` }
      }
    },
    selectedOrgUnit () {
      return this.$store.state.selectedOrgUnit
    }
  },

  watch: {
    searchText: {
      handler (newValue) {
        const trimmed = newValue.trim()
        if (trimmed === '') {
          this.showNodes = this.depth < this.autoOpenDepth
        } else {
          this.showNodes = true
        }
      },
      immediate: true
    },
    autoOpenDepth () {
      this.showNodes = this.depth < this.autoOpenDepth
    }
  },

  methods: {
    filterNode (node, searchText, selectedTree) {
      let nodeMatches = false
      if (!selectedTree || selectedTree === 'complete') {
        nodeMatches = cleanNodeName(node.name).toLowerCase().includes(searchText.trim().toLowerCase())
      }
      if (selectedTree === 'vision') {
        if (node.purpose !== '' || node.vision !== '' || node.mission !== '' || node.corporateValue !== '') nodeMatches = true
      }

      let filteredChildren = []
      if (node.nodes && node.nodes.length > 0) {
        if (!selectedTree || selectedTree === 'complete') {
          filteredChildren = node.nodes
            .map(child => this.filterNode(child, searchText, selectedTree))
            .filter(child => child !== null)
        }
        if (selectedTree === 'vision') {
          filteredChildren = node.nodes
            .map(child => this.filterNode(child, searchText, selectedTree))
            .filter(child => child !== null)
          this.showNodes = true
        }
      }

      if (nodeMatches || filteredChildren.length > 0) {
        return {
          ...node,
          nodes: filteredChildren
        }
      }

      return null
    },
    async selectOrgUnit (node) {
      this.$store.commit('SET_LOADING_STATUS', true)

      await this.$store.dispatch('getOrgUnit', node.id).then(() => {
        this.$parent.orgUnitModalElementId = node.id
      })

      this.$store.commit('SET_LOADING_STATUS', false)
      window.scrollTo(0, 0)
    },
    toggleNodes () {
      this.showNodes = !this.showNodes
    }
  }
}
</script>

<style lang="scss" scoped>
.org-unit {
  .cont-icon-org-unit svg {
    margin-top: -3px;
  }
  .org-unit-name:hover {
    font-weight: bold;
  }
}
</style>
